// extracted by mini-css-extract-plugin
export default {"NFHSPlayoffsLogo":"NFHSPlayoffs-module__NFHSPlayoffsLogo__f0tH9"};